export default function defPlaceholderImage(): string {
    return 'https://cdn2.louis.de/dynamic/articles/o_pad,w_300,h_400,ha_center,va_center,c_fff::o_extension,e_webp/59.5a.4c.placeholder.JPG';
}
